export enum ERouterList {
  HOME = 'Home',
  QR_CODE = 'QrCode',
  GUEST_MEETING_PREVIEW = 'GuestMeetingPreview',
  VISIT_INFORMATION = 'VisitInformation',
  FEEDBACK = 'Feedback',
  SUMMARY = 'Summary',
  STYLESHEETS = 'stylesheets',
  MEETING_PREVIEW = 'MeetingPreview',
  MEETING = 'Meeting',
  GUEST_MEETING = 'GuestMeeting',
  NOT_READY = 'NotReady',
}
